module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTUiIGhlaWdodD0iMjU0IiB2aWV3Qm94PSIwIDAgMjU1IDI1NCI+PHJlY3Qgd2lkdGg9IjI1NCIgaGVpZ2h0PSIyNTMuMTA1IiB4PSIxMTkuMzI3IiB5PSI1OTYyLjg5NSIgZmlsbD0iI0ZGRDlGNCIgZmlsbC1ydWxlPSJldmVub2RkIiByeD0iNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExOSAtNTk2MikiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/job-description-generator-bg.svg
// module id = UIHE
// module chunks = 0